import { Alert, Button, Radio } from 'antd';
import React, { useState } from 'react';

import { MessageMethod } from '../../graphql/api/generated';
import type { User } from '../../graphql/hasura/generated';
import { displayErrorMessage, formatPhoneNumber } from '../../utils';

const RADIO_STYLE = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

interface ISendUserMessageFormProps {
  user: Pick<User, 'phoneNumber' | 'email'>;
  onSubmit: (messageMethod: MessageMethod) => Promise<void>;
  onCancel: () => void;
  submitting: boolean;
  description?: React.ReactNode;
}

export const SendUserMessageForm: React.FC<ISendUserMessageFormProps> = (props) => {
  const { user, onSubmit, onCancel, submitting, description } = props;
  const { phoneNumber, email } = user;

  let defaultMessageMethod: MessageMethod | null = null;

  if (phoneNumber) {
    defaultMessageMethod = MessageMethod.SMS;
  } else if (email) {
    defaultMessageMethod = MessageMethod.EMAIL;
  }

  const [messageMethod, setMessageMethod] = useState(defaultMessageMethod);

  return (
    <div>
      {description}
      <Radio.Group
        value={messageMethod}
        onChange={(e) => setMessageMethod(e.target.value)}
        style={{ display: 'block', marginBottom: 20 }}
      >
        <Radio
          value={MessageMethod.SMS}
          disabled={!phoneNumber}
          style={RADIO_STYLE}
        >
          {phoneNumber
            ? <>Text Message to <strong>{formatPhoneNumber(phoneNumber)}</strong></>
            : 'Text Message'}
        </Radio>
        <Radio
          value={MessageMethod.EMAIL}
          disabled={!email}
          style={RADIO_STYLE}
        >
          {email
            ? <>Email to <strong>{email}</strong></>
            : 'Email'}
        </Radio>
      </Radio.Group>
      {!phoneNumber && !email && (
        <Alert
          showIcon
          type='warning'
          message='This user has no phone number or email address'
          style={{ marginBottom: 20 }}
        />
      )}
      <Button
        type='primary'
        loading={submitting}
        disabled={!messageMethod || submitting}
        style={{ marginRight: 10 }}
        onClick={async () => {
          try {
            if (messageMethod) {
              await onSubmit(messageMethod);
            }
          } catch (error) {
            displayErrorMessage(error);
          }
        }}
      >
        {submitting ? 'Sending...' : 'Send'}
      </Button>
      <Button onClick={onCancel} disabled={submitting}>Cancel</Button>
    </div>
  );
};
